import { createApiFactory, createPlugin, createRoutableExtension, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { tenantApiRef, TenantClient } from './api';
import { rootRouteRef, tenantViewRouteRef } from './routes';

export const tenantFrontendPlugin = createPlugin({
  id: 'tenant-frontend',
  apis: [
    createApiFactory({
      api: tenantApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => 
        new TenantClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
    tenantView: tenantViewRouteRef,
  },
});

export const TenantPage = tenantFrontendPlugin.provide(
  createRoutableExtension({
    name: 'TenantPage',
    component: () => import('./components/TenantListPage').then(m => m.TenantListPage),
    mountPoint: rootRouteRef,
  }),
);

export const TenantViewPage = tenantFrontendPlugin.provide(
  createRoutableExtension({
    name: 'TenantViewPage',
    component: () => import('./components/TenantViewPage').then(m => m.TenantViewPage),
    mountPoint: tenantViewRouteRef,
  }),
);
